module.exports = __webpack_public_path__ + "static/img/1.7a83f6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/1.png
// module id = ciIy
// module chunks = 0